/*eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Button, Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import './ProviderDetails.scss';
import LeftSection from './LeftSection';
import RightSection from './RightSection';
import AffiliatedDoctors from './AffiliatedDoctors';
import GenericButton from '../../../../../../Components/GenericButton/GenericButton';
import Locations from './Locations';
import ProviderDetailsMobile from './ProviderDetailsMobile';
import { BackArrow } from '../../../../../img/findcare/FindCareSVG';
import { CLIENT_TYPES } from 'src/constants';
import SearchDetailsSkeleton from '../../skeleton/SearchDetailsSkeleton';
import FilterModal from '../../../../common/filter-modal/FilterModal';
import APIEndpoints from '../../../../../api/APIEndpoints';
import { axiosInstance } from '../../../../../../api/axios';
import { formatDoctorName } from '../../../../../utils/common';
import CustomClientError from '../../../../../errorhandling/CustomClientError';
import { t } from 'i18next';

const ProviderDetails = ({ data }) => {
  const pageInfo = useRef(null);
  const { id, coord } = useParams();
  const searchParams = useSelector(
    ({ priceCompareAdmin }) => priceCompareAdmin?.searchProviderParams,
  );
  const location = useLocation();

  const [currMemberType] = useState(location?.state?.memberType);
  const [currMemberOid] = useState(location?.state?.memberOid);

  const serviceFor = useSelector(
    ({ priceCompareAdmin }) =>
      priceCompareAdmin?.searchParamsForUI?.procedureForData,
  );

  const isMobileClient = useSelector(({ app }) => {
    return app.clientType === CLIENT_TYPES.MOBILE;
  });
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [locations, setLocations] = useState(false);
  const [affiliatedDoctors, setAffiliatedDoctors] = useState(false);
  const [affiliatedDoctorsList, setAffiliatedDoctorsList] = useState({});
  const [affiliatedDoctorsAddress, setAffiliatedDoctorsAddress] = useState();
  const [doctorDetails, setDoctorDetails] = useState({});
  const [skeletonLoader, setSkeletonLoader] = useState(true);
  const [currentAddressIndex, setCurrentAddressIndex] = useState(0);
  const [addressIndex, setAddressIndex] = useState(0);
  const [serverErrorDetails, setServerErrorDetails] = useState(true);
  //const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [skeletonLoaderAffliatedDoctors, setSkeletonLoaderAffliatedDoctors] =
    useState(false);
  const [serverErrorAffliatedDoctors, setServerErrorAffliatedDoctors] =
    useState(false);
  const [isNotFound, setIsNotFound] = useState(false);
  const navigate = useNavigate();

  const str_service_provider = `/memberoid/${currMemberOid}/membertype/${currMemberType}`;

  const fetchDoctorDetails = async () => {
    try {
      const docDetails = await axiosInstance.get(
        APIEndpoints.getDoctorDetails() + id + str_service_provider,
      );
      const currentFacilityIndex =
        docDetails?.data?.Response?.DoctorDetails?.DoctorAfflFacilities.findIndex(
          (currentFacility) =>
            currentFacility.FacilityId == location?.state?.id,
        );
      if (currentFacilityIndex != -1) {
        setAddressIndex(currentFacilityIndex);
      }
      setCurrentAddressIndex(currentFacilityIndex);
      setDoctorDetails(docDetails?.data?.Response?.DoctorDetails);
      //setDoctorDetails( mockDetails )
      setSkeletonLoader(false);
      setServerErrorDetails(false);
    } catch (e) {
      console.log(serverErrorDetails);
      setSkeletonLoader(false);
      setServerErrorDetails(true);
    }
  };

  const fetchFacilityAffiliatedDoctors = async (oid) => {
    setSkeletonLoaderAffliatedDoctors(true);
    setServerErrorAffliatedDoctors(false);
    try {
      const AffiliatedDocDetails = await axiosInstance.get(
        APIEndpoints.getFacilityAffiliatedDoctorsDetails() +
          oid +
          '/membertype/' +
          currMemberType +
          '/memberoid/' +
          currMemberOid,
      );
      setAffiliatedDoctorsList(AffiliatedDocDetails.data.Response);
      setSkeletonLoaderAffliatedDoctors(false);
      setServerErrorAffliatedDoctors(false);
      setIsNotFound(false);
    } catch (e) {
      setSkeletonLoaderAffliatedDoctors(false);
      setServerErrorAffliatedDoctors(true);
      if (e.toString().includes('404')) {
        setIsNotFound(true);
      }
    }
  };
  const fetchFacilityAffiliatedDoctorsAddress = async () => {
    try {
      const AffiliatedDocDetails = await axiosInstance.get(
        APIEndpoints.getClaimsAddressDetails() + location?.state?.id,
      );
      setAffiliatedDoctorsAddress(AffiliatedDocDetails.data.Response);
    } catch (e) {
      setAffiliatedDoctorsAddress({});
    }
  };
  useEffect(() => {
    fetchFacilityAffiliatedDoctorsAddress();
  }, [location?.state?.id]);
  useEffect(() => {
    if (!id) {
      navigate(-1);
    } else {
      setSkeletonLoader(true);
      fetchDoctorDetails();
    }
  }, []);

  const modalOpenHandler = () => {
    setShow(true);
  };

  const navigateToPreviousRoute = () => {
    navigate(-1);
  };

  //const isMobileView = () => {
  //return windowWidth < 990 ? true : false;
  //};

  const modalCloseHandler = () => {
    setShow(false);
    setLocations(false);
    setAffiliatedDoctors(false);
  };

  const onChangeHandler = (e) => {
    setCurrentAddressIndex(e.target.value);
  };

  const changeProviderLocation = () => {
    setAddressIndex(currentAddressIndex);
    modalCloseHandler();
  };

  const locationHandler = () => {
    setModalTitle(t('find_provider.locations'));
    setLocations(true);
    modalOpenHandler();
  };

  const affiliatedDoctorsHandler = (OID) => {
    fetchFacilityAffiliatedDoctors(OID);
    setModalTitle(t('find_provider.affiliated_doctors'));
    setAffiliatedDoctors(true);
    modalOpenHandler();
  };

  useEffect(() => {
    setTimeout(() => {
      if (pageInfo && pageInfo?.current) {
        pageInfo?.current?.focus();
      }
    }, 100);
  }, [doctorDetails?.FirstName]);

  return (
    <>
      <div className="find-provider-details-container">
        {skeletonLoader ? (
          <SearchDetailsSkeleton />
        ) : serverErrorDetails ? (
          <CustomClientError
            ErrorHeading="Something went wrong with the request!"
            ErrorMessage="Please try again."
            CustomClasses="p-0"
          />
        ) : (
          <>
            <Row className="mx-0">
              <span className="sr-only" tabIndex={0} ref={pageInfo}>
                Provider Details Page
              </span>
              <GenericButton
                onClick={navigateToPreviousRoute}
                variant="link"
                className="paragraph-font secondary-2 cursor-pointer provider-location-link btn-link btn p-0 m-0 pt-3 mr-3"
                ariaLabel="Click to go back to Claims Details Page."
              >
                <BackArrow className="generic-back-arrow" />
              </GenericButton>
              <h1 className="content-header">
                {formatDoctorName(
                  doctorDetails?.DoctorTitle,
                  doctorDetails?.LastName,
                  doctorDetails?.FirstName,
                  doctorDetails?.MiddleName,
                  doctorDetails?.NameSuffix,
                )}
              </h1>
            </Row>
            {!isMobileClient ? (
              <Row className="row-eq-height pt-3">
                <LeftSection
                  doctorDetails={doctorDetails}
                  addressIndex={addressIndex}
                />
                <RightSection
                  locationHandler={locationHandler}
                  affiliatedDoctorsHandler={affiliatedDoctorsHandler}
                  doctorDetails={doctorDetails}
                  addressIndex={addressIndex}
                  affiliatedDoctorsAddress={affiliatedDoctorsAddress}
                />
              </Row>
            ) : (
              <Row className="mx-0">
                <ProviderDetailsMobile
                  locationHandler={locationHandler}
                  affiliatedDoctorsHandler={affiliatedDoctorsHandler}
                  doctorDetails={doctorDetails}
                  addressIndex={addressIndex}
                  affiliatedDoctorsAddress={affiliatedDoctorsAddress}
                />
              </Row>
            )}
          </>
        )}
      </div>
      {affiliatedDoctors && (
        <FilterModal
          titleLabel={modalTitle}
          isVisible={show}
          onHide={modalCloseHandler}
          showApplyLabel="Close"
          applyFilterHandler={modalCloseHandler}
          customClasses="provider-details-modal"
          showClearFilter={false}
          showBackButton={false}
          showCancel={false}
        >
          <AffiliatedDoctors
            serverError={serverErrorAffliatedDoctors}
            skeletonLoader={skeletonLoaderAffliatedDoctors}
            affiliatedDoctorsList={affiliatedDoctorsList}
            isNotFound={isNotFound}
          />
        </FilterModal>
      )}

      {locations && (
        <FilterModal
          titleLabel={modalTitle}
          isVisible={show}
          onHide={modalCloseHandler}
          applyFilterHandler={changeProviderLocation}
          customClasses="provider-details-modal"
          showClearFilter={false}
          showBackButton={false}
        >
          <Locations
            doctorDetails={doctorDetails}
            onChangeHandler={onChangeHandler}
            currentAddressIndex={currentAddressIndex}
          />
        </FilterModal>
      )}
    </>
  );
};

export default ProviderDetails;
